import React from 'react';
import OriginalTemplate from './templates/OriginalTemplate';
import Y2KTemplate from './templates/Y2KTemplate';
import PolaroidTemplate from './templates/PolaroidTemplate';
import GlassTemplate from './templates/GlassTemplate';
import NeonTemplate from './templates/NeonTemplate';
import GradientTemplate from './templates/GradientTemplate';
import PaperTemplate from './templates/PaperTemplate';
import HoloTemplate from './templates/HoloTemplate';
import WatercolorTemplate from './templates/WatercolorTemplate';

/**
 * DownloadImage - 高品質下載組件 (完整版)
 * 根據選擇的風格，渲染對應的專屬模板
 * 支持 9 種專業設計的風格
 */
const DownloadImage = ({ 
  template = 'original', 
  language = 'zh', 
  calculatedDays = 0, 
  relationshipLabel = '在一起', 
  detailedTime = null, 
  anniversaryDate = null, 
  anniversaryType = 'couple', 
  quote = ''
}) => {
  
  // 共用 Props
  const templateProps = {
    language,
    calculatedDays,
    relationshipLabel,
    detailedTime,
    anniversaryDate,
    anniversaryType,
    quote
  };

  // 根據選擇的模板渲染對應組件
  switch (template) {
    case 'original':
      return <OriginalTemplate {...templateProps} />;
    
    case 'y2k':
      return <Y2KTemplate {...templateProps} />;
    
    case 'polaroid':
      return <PolaroidTemplate {...templateProps} />;
    
    case 'glass':
      return <GlassTemplate {...templateProps} />;
    
    case 'neon':
      return <NeonTemplate {...templateProps} />;
    
    case 'gradient':
      return <GradientTemplate {...templateProps} />;
    
    case 'paper':
      return <PaperTemplate {...templateProps} />;
    
    case 'holo':
      return <HoloTemplate {...templateProps} />;
    
    case 'watercolor':
      return <WatercolorTemplate {...templateProps} />;
    
    default:
      return <OriginalTemplate {...templateProps} />;
  }
};

export default DownloadImage;